'use strict';

define('composer/link', ['quill', 'composer/formatting'], (Quill, formatting) => {
	const Inline = Quill.import('blots/inline');

	class Link extends Inline {
		static create(value) {
			const node = super.create(value);
			value = this.sanitize(value);
			node.setAttribute('href', value);
			node.setAttribute('rel', 'noopener noreferrer');
			node.setAttribute('target', '_blank');
			node.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				formatting.dialog.link({
					text: node.innerText,
					url: node.getAttribute('href'),
				}, (url, text) => {
					node.setAttribute('href', url);
					node.innerText = text || url;
				});
			});
			return node;
		}

		static formats(domNode) {
			return domNode.getAttribute('href');
		}

		static sanitize(url) {
			return sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
		}

		format(name, value) {
			if (name !== this.statics.blotName || !value) return super.format(name, value);
			value = this.constructor.sanitize(value);
			this.domNode.setAttribute('href', value);
		}
	}
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];


	function sanitize(url, protocols) {
		const anchor = document.createElement('a');
		anchor.href = url;
		const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
		return protocols.indexOf(protocol) > -1;
	}

	return Link;
});
